import React, { createContext, useContext, useState, useCallback } from 'react';
import CustomModal from '../Components/CustomModal';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        type: 'info', // 'info', 'confirm', 'error', 'success'
        title: '',
        message: '',
        onConfirm: null,
        onCancel: null,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar'
    });

    const showModal = useCallback((config) => {
        setModalConfig({
            isOpen: true,
            type: config.type || 'info',
            title: config.title || '',
            message: config.message || '',
            onConfirm: config.onConfirm || null,
            onCancel: config.onCancel || null,
            confirmText: config.confirmText || 'Confirmar',
            cancelText: config.cancelText || 'Cancelar'
        });
    }, []);

    const hideModal = useCallback(() => {
        setModalConfig(prev => ({ ...prev, isOpen: false }));
    }, []);

    const handleConfirm = () => {
        if (modalConfig.onConfirm) modalConfig.onConfirm();
        hideModal();
    };

    const handleCancel = () => {
        if (modalConfig.onCancel) modalConfig.onCancel();
        hideModal();
    };

    return (
        <ModalContext.Provider value={{ showModal, hideModal }}>
            {children}
            <CustomModal 
                isOpen={modalConfig.isOpen}
                type={modalConfig.type}
                title={modalConfig.title}
                message={modalConfig.message}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
                confirmText={modalConfig.confirmText}
                cancelText={modalConfig.cancelText}
                onClose={hideModal}
            />
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};
